import { memo, useEffect, useState } from 'react';

import LeftSidebar from '@/components/common/LeftSidebar/LeftSidebar';
import { routes } from '@/config/routes.config';
import Router from './routing/Router';
import { EnvUtils } from '@/utils/env.utils';
import ReloadAppModal from '../ui-components/ReloadAppModal/ReloadAppModal';
import { setGlobalCookieConsent } from './services/Telemetry/AppInsights.service';

declare global {
  interface Window {
    AccessCookiePolicies: {
      SDK: {
        tabInitialise: (options: any) => Promise<any>;
      };
    };
  }
}

function App() {
  const [shouldReloadApp, setShouldReloadApp] = useState<boolean>(false);

  useEffect(() => {
    if (!EnvUtils.isDevelopment()) {
      window.AccessCookiePolicies.SDK.tabInitialise({
        config: {
          policies: ['essential', 'analytics'],
          parties: [
            {
              policy: 'analytics',
              vendors: [
                {
                  name: 'App Insights',
                  description:
                    'App Insights is a third-party service that provides monitoring and analytics for ' +
                    'applications.',
                  vendorUrl:
                    'https://www.microsoft.com/en-us/privacy/privacystatement',
                  partyType: 'Third Party',
                },
              ],
            },
          ],
          applicationId: 'a2d33c4b-6455-4412-be99-82cb8d6de1e1',
          policyVersion: '2025-06',
          policyUrl: '/public/assets/cookie-policy.html'
        },
      }).then((consentResult: any) => {
        if (consentResult.consent === '*') {
          setGlobalCookieConsent(true);
        }
        else if (consentResult.consent.some(
          (item: any) => item.vendors && item.vendors.includes('App Insights')
        )) {
          setGlobalCookieConsent(true);
        }
      });
    }
  }, []);

  if (!EnvUtils.isDevelopment()) {
    function checkAppVersion() {
      console.log('Starting version check');
      let version = localStorage.getItem('cnbVersion');
      console.log('Current version: ' + version);

      fetch('public/meta.json', { cache: 'no-store' })
        .then(response => response.json())
        .then(data => {
          console.log('meta.version: ' + data.version);
          localStorage.setItem('cnbVersion', data.version);

          if (!!version && version != data.version) {
            setShouldReloadApp(true);
          }
          else {
            setTimeout(() => {
              checkAppVersion();
            }, 60000);
          }
        });
    }

    setTimeout(() => {
      checkAppVersion();
    }, 300000);
  }

  const reloadApp = () => location.reload();

  return (
    <>
      {shouldReloadApp &&
        <ReloadAppModal
          onClose={reloadApp}
        ></ReloadAppModal>
      }
      <div className="global-scope">
        <div className="d-flex p-relative" style={{ height: '100vh' }}>
          <LeftSidebar />

          <div className="w-100" style={{ overflowY: 'auto' }}>
            <Router routes={routes} />
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(App);
